import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./i18n";

const LangContext = createContext({ lang: "id", setLang: () => {}, t: translations.id });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "id";
    return localStorage.getItem("adtreego_lang") || "id";
  });

  useEffect(() => {
    localStorage.setItem("adtreego_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
